import PropTypes from 'prop-types';
import React from 'react';

import EditButton from '@/features/merchantsPage/Page/Row/Actions/EditButton';

const Actions = ({ classes, merchantId }) => (
  <div className={classes.root}>
    <EditButton
      merchantId={merchantId}
      small={false}
      color="primary"
      variant="contained"
    />
  </div>
);

Actions.propTypes = {
  merchantId: PropTypes.number.isRequired,
};

export default Actions;
